export const APP_NAME = 'ContikPro';
export const APP_FULL_NAME = 'ContikPro Core';
export const APP_ICON_PATH = '/brand/icon.svg';
export const APP_WORDMARK_PATH = '/brand/wordmark.png';
